import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'app-decoration-figure',
    templateUrl: './decoration-figure.component.pug',
    styleUrls: ['./decoration-figure.component.less']
})
export class DecorationFigureComponent {
    @Input() src: string;

    constructor(
    ) {
    }
}
